import * as React from "react";

import { Typography } from "@material-ui/core";

import { useStyles } from "./styles";
import type { Status, StatusMap } from "./types";

export const StatusLabel: React.FC<{
  status: Status;
  stepSpecificText?: string | null;
}> = ({ status, stepSpecificText = null }) => {
  const classes = useStyles();

  if (status === "None") {
    return null;
  }

  const statusMap: StatusMap = {
    Done: {
      className: classes.statusSuccess,
      text: stepSpecificText ?? "Done",
    },
    InProgress: {},
    None: {},
    Paused: {
      className: classes.statusWarn,
      text: stepSpecificText ?? "Paused",
    },
    Reviewing: {
      className: classes.statusSuccess,
      text: stepSpecificText ?? "Reviewing",
    },
    RequiresAttention: {
      className: classes.statusWarn,
      text: stepSpecificText ?? "Respond to email",
    },
    Declined: {
      className: classes.statusError,
      text: stepSpecificText ?? "Inactive",
    },
  };

  const { className, text } = statusMap[status];

  return (
    <Typography
      className={`${className} ${classes.statusLabel}`}
      variant="subtitle1"
    >
      <strong>{text}</strong>
    </Typography>
  );
};
